import { BackendRoute } from '../../../config/index';
import { QueryKey } from '../../../constants/index';
import { useAppQuery } from '../../../hooks/use-app-query.hook';
import { ApiService } from '../../../services/index';

export type CompanyIncorporationContext = {
  earliestExistingEventDate: null | string;
  hasCompanyIncorporation: boolean;
  hasExistingEvents: boolean;
};

export const useCompanyIncorporationContext = (companyId: string, enabled = true) => {
  return useAppQuery<CompanyIncorporationContext>({
    enabled: Boolean(companyId) && enabled,
    queryKey: [QueryKey.GET_COMPANY_INCORPORATION_CONTEXT, companyId],
    queryFn: () =>
      ApiService.get<CompanyIncorporationContext>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'events', 'incorporation-context'],
      }),
  });
};
